import { Suspense, lazy } from "react";
import PrivateRoute from "./PrivateRoute";
import PageLoader from "../components/PageLoader";
import AddWorkShift from "../modules/admin/workShifts/AddWorkShift";
const AdminDashboard = lazy(() => import("../modules/admin/adminDashboard"));
const UserManagement = lazy(() =>
  import("../modules/admin/user-management/Index")
);
const CodeBook = lazy(() => import("../modules/admin/codebook"));
const AddUser = lazy(() => import("../modules/admin/user-management/AddUser"));
const CodeBookOptions = lazy(() =>
  import("../modules/admin/codebook/CodeBookOptions")
);
const RoleAndPermission = lazy(() =>
  import("../modules/admin/permission-roles/Index")
);
const EditRolePermission = lazy(() =>
  import("../modules/admin/permission-roles/EditRolePermission")
);

const Company = lazy(() => import("../modules/admin/company"));
const Benifits = lazy(() => import("../modules/admin/benefits/Index"));
const Leaves = lazy(() => import("../modules/admin/leaves/Index"));
const WorkShifts = lazy(() => import("../modules/admin/workShifts/Index"));
const AddLeave = lazy(() => import("../modules/admin/leaves/AddLeave"));
const Holidays = lazy(() => import("../modules/admin/holidays/Index"));
const NewYearHoliday = lazy(() =>
  import("../modules/admin/holidays/NewYearHoliday")
);
const CompanyBilling = lazy(() =>
  import("../modules/admin/company/CompanyBilling")
);
const Edituser = lazy(() =>
  import("../modules/admin/user-management/Edituser")
);
const Locations = lazy(() => import("../modules/admin/locations/Index"));
const LocationsDetailView = lazy(() =>
  import("../modules/admin/locations/LocationsDetailView")
);
const DocumentTemplates = lazy(() =>
  import("../modules/admin/document-templates/Index")
);

const AdminRoutes = [
  {
    path: "/admin-dashboard",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <AdminDashboard />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/usermanagement",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <UserManagement />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/usermanagement/adduser",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <AddUser />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/usermanagement/edituser/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <Edituser />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/benefits",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <Benifits />
        </PrivateRoute>
      </Suspense>
    ),
  },
  //   LEAVES
  {
    path: "/admin/leaves",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <Leaves />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/leaves/edit/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <AddLeave />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/leaves/add",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <AddLeave />
        </PrivateRoute>
      </Suspense>
    ),
  },
  //   WORK SHIFTS
  {
    path: "/admin/work-shifts",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <WorkShifts />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/work-shifts/edit/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <AddWorkShift />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/work-shifts/add",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <AddWorkShift />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/holidays",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <Holidays />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/holidays/new-year-holiday",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <NewYearHoliday />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/codebook",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <CodeBook />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/codebook/options/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <CodeBookOptions />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/permission-roles",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <RoleAndPermission />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/permission-roles/edit/:name",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN"]}>
          <EditRolePermission />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/company",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
          <Company />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/company/billing",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
          <CompanyBilling />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/locations",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
          <Locations />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/locations/details/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
          <LocationsDetailView />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/admin/document-templates",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["MASTERADMIN", "ADMIN"]}>
          <DocumentTemplates />
        </PrivateRoute>
      </Suspense>
    ),
  },
];
export default AdminRoutes;
